// src/pages/HomePage/HomePage.tsx

import React from "react";
import styles from "./HomePage.module.scss";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import heroBackground from "../../assets/background.jpg"; // 导入背景图片

const HomePage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.homePage}>
      {/* 横幅区域 */}
      <section
        className={styles.hero}
        style={{ backgroundImage: `url(${heroBackground})` }} // 内联样式设置背景图片
      >
        <div className={styles.overlay}></div> {/* 遮罩层 */}
        <h1>{t("home.heroTitle")}</h1>
        <p>{t("home.heroSubtitle")}</p>
        <div className={styles.buttonGroup}>
          <Link to="/quote/basic" className={styles.ctaButton}>
            {t("home.ctaButton")}
          </Link>
          <Link to="/appointment" className={styles.ctaButton}>
            {t("home.appointmentButton")}
          </Link>
          <Link to="/docs" className={styles.ctaButton}>
            {t("nav.docs")}
          </Link>
        </div>
      </section>

      {/* 其他内容可以在此添加 */}
    </div>
  );
};

export default HomePage;
